import React from 'react'
import BgAmine from './BgAnime2'
import Banner from './Banner'
import Abilities from './Abilities'
import HighLight from './HighLight'
import Confidence from './Confidence'
import Model from './Model'
import Roadmap from './Roadmap'
import Team from './Team'

const Home: React.FC = () => {
  return (
    <>
      <BgAmine />
      <Banner />
      <Abilities />
      <HighLight />
      <Confidence />
      <Model />
      <Roadmap />
      <Team />
    </>
  )
}

export default Home
